// extracted by mini-css-extract-plugin
export default {"notAuth":"Content_notAuth__uA2K2","content":"Content_content__--EXu"};